import { render, staticRenderFns } from "./PosProducts.vue?vue&type=template&id=67d842e5&"
import script from "./PosProducts.vue?vue&type=script&lang=js&"
export * from "./PosProducts.vue?vue&type=script&lang=js&"
import style0 from "./PosProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports